module.exports = __webpack_public_path__ + "img/1617.8328356d.png";